import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isoWeek from 'dayjs/plugin/isoWeek'
import relativeTime from 'dayjs/plugin/relativeTime'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)
dayjs.extend(customParseFormat)
dayjs.extend(advancedFormat)
dayjs.extend(isoWeek)

dayjs.Ls.en.weekStart = 1

export const parseDate = (value) => {
  if (!value) {
    return dayjs()
  }

  if (dayjs.isDayjs(value)) {
    return value
  }

  return dayjs(value)
}

export const formatDate = (value, format) => parseDate(value).format(format)

export const formatFromNow = (value) => (value ? parseDate(value).fromNow() : '')

export const checkDayjs = (date) =>
  date && (dayjs.isDayjs(date) || parseDate(date).isValid()) ? parseDate(date) : null

export const getTimezoneOptions = () => {
  const names =
    typeof Intl !== 'undefined' && Intl.supportedValuesOf
      ? Intl.supportedValuesOf('timeZone')
      : ['UTC', 'Asia/Kolkata', 'Europe/London', 'America/New_York']

  return names
    .map((item) => ({
      value: item,
      label: `(GMT${dayjs.tz(dayjs(), item).format('Z')}) ${new Date()
        .toLocaleDateString(undefined, { day: '2-digit', timeZone: item, timeZoneName: 'long' })
        .substring(4)} (${item})`
    }))
    .sort((a, b) => {
      const [ahh, amm] = a.label.split('GMT')[1].split(')')[0].split(':')
      const [bhh, bmm] = b.label.split('GMT')[1].split(')')[0].split(':')

      return +ahh * 60 + (+amm || 0) - (+bhh * 60 + (+bmm || 0))
    })
}

export { dayjs }
export default dayjs
